module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/170731-003-FU-7c54351d93ef8687481652cec9f29761.jpg";